export const API_URL = "https://x-clients-be.onrender.com";
export const API_DOCS_URL = API_URL + "/docs";
export const REPO_URL = "https://github.com/Inzhenerka/qa_stand_employees"
